export const messages = {
    "wr-dashboard.search.input.hint": "Buscar",
    "wr-dashboard.search.label.breadcrumb": "Resultados de la búsqueda",
    "wr-dashboard.search.message.empty": "No hay ningún artículo que coincida con su búsqueda",
    "wr-dashboard.side-bar.selected.title:plural": "{count} artículos seleccionados | {count} artículo seleccionado | {count} artículos seleccionados",
    "wr-dashboard.side-bar.backup-type.disk": "Disco",
    "wr-dashboard.side-bar.backup-type.file": "Archivo",
    "wr-dashboard.side-bar.backup-type.notarized": "Archivos y carpetas certificados",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplicación: Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplicación: Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplicación: estado del sistema",
    "wr-dashboard.side-bar.backup-type.application": "Aplicación",
    "wr-dashboard.backups-table.column.name": "Nombre",
    "wr-dashboard.backups-table.column.size": "Tamaño",
    "wr-dashboard.backups-table.column.version": "Última versión",
    "wr-dashboard.backups-table.action.delete": "Eliminar",
    "wr-dashboard.backups-table.message.no-backups": "Todavía no hay ninguna copia de seguridad en la nube",
    "wr-dashboard.backups-sidebar.label.size": "Tamaño",
    "wr-dashboard.backups-sidebar.label.type": "Tipo",
    "wr-dashboard.backups-sidebar.label.version": "Última versión",
    "wr-dashboard.backups-sidebar.label.created": "Creado",
    "wr-dashboard.backups-sidebar.label.machine": "Equipo",
    "wr-dashboard.backups-sidebar.label.owner": "Propietario",
    "wr-dashboard.content-table.column.name": "Nombre",
    "wr-dashboard.content-table.column.versions": "Versiones",
    "wr-dashboard.content-table.column.volumes": "Volúmenes",
    "wr-dashboard.content-table.column.path": "Ruta",
    "wr-dashboard.content-table.column.size": "Tamaño",
    "wr-dashboard.content-table.column.version": "Última versión",
    "wr-dashboard.content-table.action.notary-verify": "Verificar",
    "wr-dashboard.content-table.action.notary-get-crt": "Obtener certificado",
    "wr-dashboard.content-table.action.asign": "Enviar para su firma",
    "wr-dashboard.content-table.action.versions": "Versiones",
    "wr-dashboard.content-table.action.restore": "Descargar",
    "wr-dashboard.content-table.label.size": "Tamaño",
    "wr-dashboard.content-table.label.created": "Creado",
    "wr-dashboard.content-table.label.modified": "Modificado",
    "wr-dashboard.content-table.message.empty-folder": "Esta carpeta está vacía",
    "wr-dashboard.password-dialog-box.title.backup": "Copia de seguridad cifrada",
    "wr-dashboard.password-dialog-box.title.archive": "Archivo comprimido cifrado",
    "wr-dashboard.password-dialog-box.message.backup": "Especifique la contraseña para acceder a la copia de seguridad {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Especifique la contraseña para acceder al archivo comprimido {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Contraseña",
    "wr-dashboard.password-dialog-box.message.invalid-password": "La contraseña es incorrecta",
    "wr-dashboard.form.button.open": "Abrir",
    "wr-dashboard.form.button.close": "Cerrar",
    "wr-dashboard.form.button.cancel": "Cancelar",
    "wr-dashboard.form.button.continue": "Continuar",
    "wr-dashboard.form.button.proceed": "Continuar",
    "wr-dashboard.form.button.delete": "Eliminar",
    "wr-dashboard.form.button.done": "Listo",
    "wr-dashboard.form.button.retry": "Reintentar",
    "wr-dashboard.notary.verify.view.status.downloading": "Descargando...",
    "wr-dashboard.notary.verify.view.status.validating": "Validando...",
    "wr-dashboard.notary.verify.view.status.pending": "Certificado pendiente...",
    "wr-dashboard.notary.verify.view.status.fail": "Error de certificado...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Obtener certificado",
    "wr-dashboard.notary.verify.view.file-info.name": "NOMBRE",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "FIRMADO POR",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "FECHA DE LA COPIA DE SEGURIDAD",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "FECHA DEL CERTIFICADO",
    "wr-dashboard.notary.verify.view.button.cancel": "Cancelar",
    "wr-dashboard.notary.verify.view.button.done": "Listo",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versión de navegador no compatible",
    "wr-dashboard.versions-dialog-box.title": "Versiones de {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Enviar para su firma",
    "wr-dashboard.asign-dialog-box.message": "La versión del archivo se comparte, pero nadie puede ver el archivo si no tiene el enlace a él. Vaya a ASign para añadir signatarios y compartir el enlace.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Mostrar detalles del archivo",
    "wr-dashboard.page-not-found.title": "Página no encontrada",
    "wr-dashboard.page-not-found.message.main": "No se ha encontrado la página que estaba buscando.",
    "wr-dashboard.page-not-found.message.description": "Puede que el enlace esté desactualizado o que haya escrito la dirección de forma incorrecta.",
    "wr-dashboard.page-not-found.message.error": "Código de error: 404",
    "wr-dashboard.server-error.title": "El servidor no está disponible",
    "wr-dashboard.server-error.message": "El servidor no está disponible en este momento. Inténtelo de nuevo más tarde.",
    "wr-dashboard.server-error.message.error": "Código de error: 500",
    "wr-dashboard.account-menu.action.sign-out": "Cerrar sesión",
    "wr-dashboard.breadcrumb.item.machines": "Equipos",
    "wr-dashboard.breadcrumb.item.failed-backups": "Copias de seguridad fallidas",
    "wr-dashboard.machines-table.column.name": "Nombre",
    "wr-dashboard.machines-table.column.size": "Tamaño",
    "wr-dashboard.machines-table.message.no-machines": "Todavía no hay equipos en la nube",
    "wr-dashboard.incomplete-backups.message.status:plural": "Hay {count} copias de seguridad fallidas o incompletas ocupando {size} de almacenamiento | Hay {count} copia de seguridad fallida o incompleta ocupando {size} de almacenamiento | Hay {count} copias de seguridad fallidas o incompletas ocupando {size} de almacenamiento",
    "wr-dashboard.incomplete-backups.button.view": " Ver copias de seguridad",
    "wr-dashboard.incomplete-backups.button.delete": "Eliminar copias de seguridad",
    "wr-dashboard.machines-table.message.space-used:plural": "Uso total de las copias de seguridad {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Eliminar archivos",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Eliminar los archivos incompletos",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Eliminar todos los archivos incompletos",
    "wr-dashboard.delete-archive.message": "¿Seguro que desea eliminar de forma permanente los archivos seleccionados de todas las ubicaciones? Todos los datos se eliminarán y no podrán recuperarse.",
    "wr-dashboard.certificate-pending-dialog-box.title": "El certificado está pendiente",
    "wr-dashboard.certificate-pending-dialog-box.message": "Inténtelo de nuevo dentro de unos minutos.",
    "wr-dashboard.form.button.ok": "Aceptar"
};
